import React, { lazy } from 'react';
export function OilProblemSection() {
  return <section className="py-12 border-b border-gray-200" data-id="element-521">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6" data-id="element-522">
        The Specialist Who Couldn't Save Herself
      </h2>
      <div className="mb-2" data-id="element-523">
        <img src="https://cdn.shopify.com/s/files/1/0679/7135/0570/files/Gemini_Generated_Image_b7e8zsb7e8zsb7e8.png?v=1761119167" alt="Discarded eye drop bottles in a trash bin with red X marks indicating they're not effective solutions" className="rounded-lg w-full h-auto shadow-md mb-4" width="800" height="450" loading="lazy" onError={e => {
        e.currentTarget.onerror = null;
        e.currentTarget.src = 'https://placehold.co/600x400/e2e8f0/64748b?text=Eye+Drops+Ineffective';
      }} data-id="element-524" />
      </div>
      <div classname="bg-white rounded-lg p-6 shadow-md text-gray-800 leading-relaxed max-w-2xl mx-auto" data-id="element-525">
        <div className="md:w-full" data-id="element-526">
        <div className="bg-white rounded-lg p-6 shadow-md text-gray-800 leading-relaxed max-w-2xl mx-auto" data-id="element-527">
          <p className="mb-4" data-id="element-528">
    I was sitting at my desk, squinting at <span className="text-teal-600 font-semibold" data-id="element-529">Mrs. Patterson's chart</span> through tears that wouldn't stop.
    My fourth patient of the morning. And I couldn't read my own handwriting.
  </p>

  <p className="mb-4" data-id="element-530">
    Not because my vision was failing but because my eyes were so <strong data-id="element-531">inflamed</strong>, so completely <strong data-id="element-532">exhausted</strong>,
    that focusing felt like staring into sand.
  </p>

  <p className="mb-4" data-id="element-533">
    I reached for my drops... The same <strong data-id="element-534">premium bottle</strong> I'd been recommending to patients for years.
  </p>

  <p className="mb-4 font-semibold text-teal-600" data-id="element-535">
    My hand froze.
  </p>

  <p className="mb-4" data-id="element-536">
    <strong data-id="element-537">Board-certified ophthalmologist.</strong> 14 years of practice. And here I was, unable to examine a
    simple patient chart without my eyes staging a full rebellion.
  </p>

  <p className="mb-4" data-id="element-538">
    How many bottles had I burned through this month alone? <strong data-id="element-539">Three? Five?</strong>
  </p>

  <p className="mb-4" data-id="element-540">
    The woman who'd built a career on <span className="text-teal-600 font-semibold" data-id="element-541">seeing</span> could barely trust her own eyes anymore.
  </p>

  <p className="mb-4" data-id="element-542">
    And the cruelest part? I was about to walk into that exam room and prescribe Mrs. Patterson the
    exact same “solution” that was <strong data-id="element-543">systematically destroying my oil glands.</strong>
  </p>

  <p className="mb-4" data-id="element-544">
    Something inside me snapped. Not my determination but <span className="text-teal-600 font-semibold" data-id="element-545">the lie I’d been living.</span>
  </p>

  <p className="mb-4" data-id="element-546">
    I set down the bottle. For the first time in months, I asked the question I should have been asking all along:
  </p>

  <blockquote className="border-l-4 border-teal-500 pl-4 italic text-gray-700 mb-4" data-id="element-547">
    “<span className="text-teal-600 font-semibold" data-id="element-548">What if everything we've been taught is backwards?</span>”
  </blockquote>

  <p className="mb-4" data-id="element-549">
    That afternoon, I started reading. Not the marketing materials from drop manufacturers,
    but instead <strong data-id="element-550">actual research</strong> the peer-reviewed studies gathering dust in medical journals.
  </p>

  <p className="mb-4" data-id="element-551">
    And buried in those pages was <span className="text-teal-600 font-semibold" data-id="element-552">the answer that changed everything.</span>
  </p>

  <p className="mb-4" data-id="element-553">
    Not another bottle. Not another prescription to refill every month.
  </p>

  <p className="mb-4" data-id="element-554">
    But <strong className="text-teal-600" data-id="element-555">pulsating pressure & controlled therapeutic heat at precisely 42°C.</strong>The same principle behind those
    <strong data-id="element-556"> $1,500 in-office treatments </strong> insurance won't cover.
  </p>

  <p className="mb-4" data-id="element-557">
    The kind of heat that actually <strong data-id="element-558">melts hardened oil</strong>. That <strong data-id="element-559">restores natural flow</strong>.
    That <span className="text-teal-600 font-semibold" data-id="element-560">addresses the cause instead of masking symptoms.</span>
  </p>

  <p className="mb-4" data-id="element-561">
    That day became my <strong className="text-teal-600" data-id="element-562">turning point.</strong> It's when I finally stopped chasing relief
    and started <strong data-id="element-563">rebuilding what my eyes had lost.</strong>
  </p>
        </div>
        </div>
      </div>
    </section>;
}